import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { BASE_URL } from "../Config";

export function useNotifications(role = "user") {
  const [notifications, setNotifications] = useState([]);
  const token = sessionStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };

  const url = role === "admin"
    ? `${BASE_URL}/notifications/admin`
    : `${BASE_URL}/notifications`;

  const markReadUrl = role === "admin"
    ? `${BASE_URL}/notifications/admin/read`
    : `${BASE_URL}/notifications/read`;

  const fetch = useCallback(async () => {
    try {
      const res = await axios.get(url, { headers });
      setNotifications(res.data.notifications ?? []);
    } catch { /* silent */ }
  }, [url]);

  // Poll every 30s
  useEffect(() => {
    fetch();
    const interval = setInterval(fetch, 30000);
    return () => clearInterval(interval);
  }, [fetch]);

  const markAllRead = async () => {
    try {
      await axios.patch(markReadUrl, {}, { headers });
      setNotifications(prev => prev.map(n => ({ ...n, read: true })));
    } catch { /* silent */ }
  };

  const unreadCount = notifications.filter(n => !n.read).length;

  return { notifications, unreadCount, markAllRead, refetch: fetch };
}